import {cadType, objectType} from "_src/constants";
import ObjectWrapper from "_src/object_wrapper";
import primitiveFactory from "_src/engine/factories/primitive";
import {primitiveType} from "_src/engine/constants";

export default class CadWrapper extends ObjectWrapper {
  constructor(params) {
    super(params);
    this.type = objectType.CAD;

    this.edgesModel = params.edgesModel !== undefined ? params.edgesModel : null;
  }

  isPrimitive() {
    return this.getSubType() !== cadType.MODEL;
  }

  getSubType() {
    return this._selfPropertyGetter("cadType");
  }

  getModelData() {
    return this._selfPropertyGetter("cadData");
  }

  setVisibility(visible) {
    super.setVisibility(visible);
    if (this.edgesModel) this.edgesModel.setVisibility(visible);
  }

  setOpacity(opacity) {
    super.setOpacity(opacity);
    if (this.edgesModel) this.edgesModel.setOpacity(opacity);
  }

  move(matrix, withPropertyUpdate = false) {
    super.move(matrix, withPropertyUpdate);

    if (this.edgesModel) this.edgesModel.setMatrix(matrix);
  }

  async _loadFrames(properties, level) {
    await super._loadFrames(properties, level);
    if (!this.edgesModel) return;

    for (const edgeFrame of this.frames) {
      for (const edgeChunk of edgeFrame.model.chunks) {
        const points = edgeChunk.geometry.getItemBuffer("a_position");
        const primitives = edgeChunk.geometry.getItemBuffer("edges_indices");
        if (!primitives) continue;

        const chunk = primitiveFactory.create(primitiveType.LINE_ARRAY, { points, primitives });
        this.edgesModel.addGeometryChunk(chunk);
      }
    }
    this.edgesModel.setVisibility(this.getVisibility());
    this.edgesModel.setFrustrumCulling(false);
  }
}
